import { CardBrand } from '@afterpay/types'
import { IconSizes } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import { CardDetails } from '@afterpaytouch/portal-api'
import { getLast, pascalCase } from '@afterpay/utils/string'
import { PaymentMethodIcon } from '../PaymentMethodIcon'
import { PaymentMethod } from './PaymentMethod'
import { PaymentMethodInfo } from './PaymentMethodInfo'

interface Props {
  card?: CardDetails
  reversed?: boolean
  iconSize?: IconSizes
  disabled?: boolean
}

export const CardPayment: FunctionComponent<Props> = ({ card, iconSize, disabled }) => {
  const charactersToRender = card?.cardBrand === CardBrand.AMEX ? 3 : 4
  const accountNumberMask = getLast(card?.maskedPan, charactersToRender)

  const cardBrand = pascalCase(card?.cardBrand?.toString() ?? '')

  return (
    <PaymentMethod
      icon={<PaymentMethodIcon type={card?.cardBrand} size={iconSize} />}
      paymentMethodName={cardBrand}
      paymentMethodInfo={<PaymentMethodInfo expiryDate={card?.expiryDate} hasSeparator paymentMethodMasks={accountNumberMask} />}
      disabled={disabled}
    />
  )
}
